export default {
  autocompletePaymentMethods: [],
  paymentMethods: [],
  emptyPaymentMethod: {},
  params: {
    entity: [],
    collection: []
  }
}